// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"580cde45","732":"e6741a77","977":"12ed0bb4"}[chunkId] + ".chunk.js";
};